



























































































import { SortOrder } from '@/jbi-shared/types/search.types';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import BasePagination from '../../../components/base/BasePagination.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import BaseTable from '../../../components/BaseTable.vue';
import SortableTableHeader from '../../../components/SortableTableHeader.vue';
import TableActionDropdown from '../../../components/TableActionDropdown.vue';
import { GroupLevelAttribute } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { RootState } from '@/store/store';
import EditAttributeModal from '@/views/AdminGroupManagement/components/EditAttributeModal.vue';
import { DialogProgrammatic, ToastProgrammatic } from 'buefy';
import { Vue } from 'vue-property-decorator';
import delay from 'delay';
import { PermissionsMatrixActionsEnum } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { isUserAllowed } from '@/utils/rbac.util';
import { EntityTypes } from '@/store/modules/module-tree/enums/module-tree.enums';

@Component({
  computed: {
    PermissionsMatrixActionsEnum() {
      return PermissionsMatrixActionsEnum;
    }
  },
  components: {
    BasePagination,
    BaseTable,
    BaseLoading,
    TableActionDropdown,
    SortableTableHeader
  }
})
export default class GroupLevelAttributeList extends mixins(PaginationMixin) {
  @Prop() public items!: GroupLevelAttribute[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: SortOrder;

  @State(
    ({ admin }: RootState) =>
      admin.apiState.getPaginatedGroupLevelAttributes.success
  )
  public getPaginatedGroupLevelAttributesSuccess!: boolean;

  @State((state: RootState) => state.rbac.groupTypesUserHasAccessTo)
  groupTypesUserHasAccessTo!: string[];

  @State((state: RootState) => state.rbac.groupsUserHasAccessTo)
  groupsUserHasAccessTo!: number[];

  @Action('admin/deleteGroupLevelAttribute')
  deleteGroupLevelAttribute!: (attributeId: number) => Promise<void>;

  sortHeaders: Array<{
    placeholder: string;
    sortColumn?: string;
    sort?: boolean;
  }> = [
    {
      placeholder: 'Attribute Label',
      sortColumn: 'attributeLabel',
      sort: true
    },
    { placeholder: 'Content Type', sortColumn: 'contentType', sort: true },
    { placeholder: 'Groups', sortColumn: 'groupCount', sort: true }
  ];

  public isUserAllowed(
    action: PermissionsMatrixActionsEnum,
    module: string
  ): boolean {
    return isUserAllowed(action, module);
  }

  public onClickHeaderColumn(columnName: string): void {
    if (this.sortColumn === columnName) {
      this.$emit('sort', {
        sortColumn: columnName,
        sortOrder:
          this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      });
      return;
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    });
  }

  public getSortOrderOfColumn(name: string | undefined): SortOrder {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }

  public onEditAttribute(attribute: GroupLevelAttribute): void {
    this.$buefy.modal.open({
      parent: this,
      component: EditAttributeModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: false,
      props: {
        attributeId: attribute.id
      },
      events: {
        attributeUpdateSuccess: (): void => {
          this.$emit('updateAttributeList');
        }
      }
    });
  }

  async onDeleteAttribute(attribute: GroupLevelAttribute): Promise<void> {
    const dialogElem: Vue = DialogProgrammatic.confirm({
      message: `<p class="buefy-dialog-title">Delete Attribute?</p><p class="buefy-dialog-content">
          You are trying to delete <b>${attribute.label}</b>. Deleting this attribute will also delete it from its associated group(s) and it cannot be undone.
        </p>`,
      confirmText: 'Cancel',
      onConfirm: () => undefined,
      canCancel: ['button'],
      cancelText: 'Delete',
      type: 'is-primary',
      onCancel: async () => {
        await this.deleteGroupLevelAttribute(attribute.id!);
        ToastProgrammatic.open({
          queue: true,
          type: 'is-dark',
          position: 'is-top',
          message: `Attribute ${attribute.label} successfully deleted.`,
          duration: 5000
        });
        this.$emit('updateAttributeList');
      }
    });

    while (!dialogElem.$el?.querySelector) {
      await delay(50);
    }
    const cancelBtn = dialogElem.$el?.querySelector?.(
      `.modal-card > footer > button:first-child`
    );
    cancelBtn?.classList?.add?.(`is-red`);
  }

  public checkForPermissions(
    action: PermissionsMatrixActionsEnum,
    module: string,
    skipImplicitCheck?: boolean
  ): boolean {
    const groupTypeName = this.groupTypesUserHasAccessTo
      ? this.groupTypesUserHasAccessTo
      : undefined;
    const groupId = this.groupsUserHasAccessTo
      ? this.groupsUserHasAccessTo
      : undefined;
    return isUserAllowed(
      action,
      module,
      EntityTypes.GROUP,
      groupTypeName,
      groupId,
      undefined,
      skipImplicitCheck
    );
  }
}
